import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-features-style-seven',
  templateUrl: './features-style-seven.component.html',
  styleUrls: ['./features-style-seven.component.scss']
})
export class FeaturesStyleSevenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
